module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "pa-4"
  }, [(_vm.data) ? _c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "justify-space-between": ""
    }
  }, [_c('h2', {
    staticClass: "mb-4"
  }, [_vm._v("Preview")]), _vm._v(" "), _c('v-btn', {
    staticClass: "close-btn",
    attrs: {
      "fab": "",
      "small": "",
      "flat": "",
      "absolute": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content-wrap"
  }, [(_vm.data.prefixLines.length > 0) ? _c('div', {
    staticClass: "prefix-wrap pa-3"
  }, [_vm._l((_vm.data.prefixLines), function(prefix, i) {
    return [(prefix.content === 'emptyline') ? _c('p', {
      key: i,
      staticClass: "pb-3"
    }) : (prefix.content === 'lineseparator') ? _c('hr', {
      key: i,
      staticClass: "my-3 lineseparator"
    }) : (prefix.content === 'equalseparator') ? _c('hr', {
      key: i,
      staticClass: "my-3 equalseparator"
    }) : (prefix.content === 'image') ? _c('div', {
      key: i,
      staticClass: "img-wrap"
    }, [_c('img', {
      attrs: {
        "src": prefix.data,
        "alt": ""
      }
    })]) : _c('p', {
      key: i,
      staticClass: "mb-0",
      style: ({
        fontSize: ((prefix.fontHeight) + "px"),
        fontWeight: prefix.fontStyle === 'bold' ? 'bold' : null,
        fontStyle: prefix.fontStyle === 'italic' ? 'italic' : null,
      })
    }, [_vm._v("\n            " + _vm._s(prefix.content === 'opencashdrawer' ? 'open cashdrawer' : prefix.content) + "\n          ")])]
  })], 2) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "content mb-0 pa-3"
  }, [_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Harum enim, perspiciatis,\n        animi magnam vel placeat consequatur nisi architecto aut iure repudiandae debitis itaque fugit.\n        Omnis facilis illo laudantium consequuntur perspiciatis?")]), _vm._v(" "), (_vm.data.postfixLines.length > 0) ? _c('div', {
    staticClass: "postfix-wrap pa-3"
  }, [_vm._l((_vm.data.postfixLines), function(postfix, index) {
    return [(postfix.content === 'emptyline') ? _c('p', {
      key: index,
      staticClass: "pb-3"
    }) : (postfix.content === 'lineseparator') ? _c('hr', {
      key: index,
      staticClass: "my-3 lineseparator"
    }) : (postfix.content === 'equalseparator') ? _c('hr', {
      key: index,
      staticClass: "my-3 equalseparator"
    }) : (postfix.content === 'image') ? _c('div', {
      key: index,
      staticClass: "img-wrap"
    }, [_c('img', {
      attrs: {
        "src": postfix.data,
        "alt": ""
      }
    })]) : _c('p', {
      key: index,
      staticClass: "mb-0",
      style: ({
        fontSize: ((postfix.fontHeight) + "px"),
        fontWeight: postfix.fontStyle === 'bold' ? 'bold' : null,
        fontStyle: postfix.fontStyle === 'italic' ? 'italic' : null,
      })
    }, [_vm._v("\n            " + _vm._s(postfix.content === 'opencashdrawer' ? 'open cashdrawer' : postfix.content) + "\n          ")])]
  })], 2) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.image) ? _c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "justify-space-between": ""
    }
  }, [_c('h2', {
    staticClass: "mb-4"
  }, [_vm._v("Preview")]), _vm._v(" "), _c('v-btn', {
    staticClass: "close-btn",
    attrs: {
      "fab": "",
      "small": "",
      "flat": "",
      "absolute": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content-wrap"
  }, [_c('div', {
    staticClass: "prefix-wrap pa-3"
  }, [_c('div', {
    staticClass: "img-wrap fluid"
  }, [_c('img', {
    attrs: {
      "src": _vm.image.base64Image,
      "alt": ""
    }
  })])])])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-077c9f05","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/PreviewPrePost.vue
// module id = 566
// module chunks = 4